import { ApiBaseServiceProvider } from '@/services/api-providers/ApiBaseServiceProvider';
import axios from 'axios';

export enum AiGenerationType {
  TEXT = 'text',
  NOTES = 'notes',
  PARAGRAPHS = 'paragraphs',
  TRANSCRIPTION = 'transcription',
  IMAGE = 'image',
}

export enum AiGenerationStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  ERROR = 'error',
  CANCELLED = 'cancelled',
}

export interface AiGenerationStatusResponse {
  id: string;
  articleId: string;
  generationType: AiGenerationType;
  status: AiGenerationStatus;
  progress: number; // 0-100
  result?: any;
  error?: string;
  startedAt: string;
  completedAt?: string;
  updatedAt: string;
}

export interface StartGenerationResponse {
  statusId: string;
  articleId: string;
  generationType: AiGenerationType;
  status: AiGenerationStatus;
  message: string;
}

export class AiGenerationServiceProvider extends ApiBaseServiceProvider {
  scope = 'ai';

  // Text Generation
  startTextGeneration = (data: {
    articleId: string;
    prompt?: string;
    isConsiderArticle?: boolean;
    saveArticle?: boolean;
    selectedText?: string;
    writerType?: string;
    option?: string;
    predefinedPrompt?: string;
  }) => {
    return axios.post<StartGenerationResponse>(`${this.getBaseUrl()}/text/generate`, data, this.getRequestConfig());
  };

  // Smart Notes Generation
  startNotesGeneration = (data: {
    articleId: string;
    prompt?: string;
    tone?: string;
    predefinedPrompt?: string;
    saveArticle?: boolean;
    isConsiderArticle?: boolean;
  }) => {
    return axios.post<StartGenerationResponse>(`${this.getBaseUrl()}notes/generate`, data, this.getRequestConfig());
  };

  // Paragraphs Generation
  startParagraphsGeneration = (data: { articleId: string }) => {
    return axios.post<StartGenerationResponse>(
      `${this.getBaseUrl()}paragraphs/generate`,
      data,
      this.getRequestConfig()
    );
  };

  // Transcription Generation
  startTranscriptionGeneration = (data: { articleId: string }) => {
    return axios.post<StartGenerationResponse>(
      `${this.getBaseUrl()}transcription/generate`,
      data,
      this.getRequestConfig()
    );
  };

  // Image Generation
  startImageGeneration = (data: { articleId?: string; prompt: string; style?: string }) => {
    return axios.post<StartGenerationResponse>(`${this.getBaseUrl()}image/generate`, data, this.getRequestConfig());
  };

  // Status Polling
  getGenerationStatus = (type: AiGenerationType, articleId: string) => {
    return axios.get<AiGenerationStatusResponse>(
      `${this.getBaseUrl()}generation/status/${type}/${articleId}`,
      this.getRequestConfig()
    );
  };

  // Cancel Generation
  cancelGeneration = (type: AiGenerationType, articleId: string) => {
    return axios.post<any>(`${this.getBaseUrl()}generation/cancel/${type}/${articleId}`, {}, this.getRequestConfig());
  };
}
